import { DEFAULT_PERMISSIONS } from '@/constants/constants';
import { Source } from '@/Interface/source';
import { SourceModel } from '@/model/source';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PermissionsService } from '@services/permissions.service';
import { UtilityService } from '@services/utility.service';
import Swal from "sweetalert2";
@Component({
  selector: 'app-source',
  templateUrl: './source.component.html',
  styleUrls: ['./source.component.scss']
})
export class SourceComponent implements OnInit {
  source: Source[];
  addSourceModel = new SourceModel();
  updateSourceModel = new SourceModel();
  addSourceForm: FormGroup;
  updateSourceForm: FormGroup;
  loader: boolean;
  // Separate from `loader`: this one is scoped to the table, so a filter,
  // a search keystroke or a page change no longer blanks the whole page.
  tableLoader: boolean = false;
  permissions = { ...DEFAULT_PERMISSIONS };
  permissionsReady: boolean = false;
  constructor(
    private modalService: NgbModal,
    private _utilityService: UtilityService,
    private permService: PermissionsService,
    private formBuilder: FormBuilder
  ) { }
  ngOnInit(): void {
    this.initComponent()
  }
  async initComponent() {
    this.loader = true
    await this.getComponentPermissions();

    this.addSourceForm = this.formBuilder.group({
      sourcName: new FormControl(null, Validators.required)
    })
    this.updateSourceForm = this.formBuilder.group({
      sourcNameupdate: new FormControl(null, Validators.required)
    })
    if (this.permissions.canView) {
      this.getSource();
    }
    setTimeout(() => {
      this.loader = false
    }, 250);
  }

  async getComponentPermissions() {
    const url = this.permService.getCurrentUrl();
    // const menuFromLocal = this.permService.loadMenuFromLocalStorage();
    const menuFromLocal = await this.permService.waitForMenuInLocalStorage();

    const matchedMenu = this.permService.findMenuPermissions(menuFromLocal, url);

    this.permissions = matchedMenu
      ? {
        canAdd: !!matchedMenu.canAdd,
        canEdit: !!matchedMenu.canEdit,
        canView: !!matchedMenu.canView,
        canDelete: !!matchedMenu.canDelete
      }
      : { ...DEFAULT_PERMISSIONS };

    this.permissionsReady = true;
  }
  get hasAnyActionPermission(): boolean {
    return (
      this.permissionsReady &&
      (this.permissions.canView ||
        this.permissions.canEdit ||
        this.permissions.canDelete)
    );
  }
  open(item: Source, content: any) {
    this.modalService.open(content, { centered: true });
    var getUpdateId = item.id;
    this._utilityService.getSourceByid(getUpdateId).subscribe((res) => {
      if (res) {
        this.updateSourceModel = res[0];
        this.updateSourceForm.patchValue({
          sourcNameupdate: this.updateSourceModel.getName()
        })
      }
    });
  }

  getSource() {
    this.tableLoader = true
    this._utilityService.receiveSource().subscribe((res) => {
      if (res) {
        this.source = res;
      }
    });
    setTimeout(() => {
      this.tableLoader = false
    }, 250);
  }

  addSourceOpen(addConent: any) {
    this.modalService.open(addConent, { centered: true });
  }

  addSource() {
    this.source = null;
    this.addSourceModel.name = this.addSourceForm.value.sourcName;
    this._utilityService.addSourceList(this.addSourceModel).subscribe((res) => {
      if (res) {
        this.getSource();
        this.addSourceForm.reset();
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: '`<h2>Source Successfully Added</h2>`',
          showConfirmButton: false,
          timer: 1500
        })
      }
    })
  }

  deleteSource(item: Source) {
    var deleteSource = item.id;
    Swal.fire({
      title: 'Are you sure to delete this Source?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        this._utilityService.deleteSourceList(deleteSource).subscribe((res) => {
          if (res) {
            this.getSource();
          }
        })
        Swal.fire(
          'Deleted!',
          'Source has been deleted.',
          'success'
        )
      }
    })

  }

  updateSource() {
    this.updateSourceModel.id = this.updateSourceModel.id;
    this.updateSourceModel.name = this.updateSourceForm.value.sourcNameupdate;
    this._utilityService.updateSourceList(this.updateSourceModel).subscribe((res) => {
      if (res) {
        this.getSource();
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: '`<h2>Source  Successfully Updated</h2>`',
          showConfirmButton: false,
          timer: 1500
        })
      }
    })
  }
}
